var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-tree", {
    ref: "tree",
    attrs: {
      data: _vm.data,
      "show-checkbox": "",
      "default-expand-all": _vm.defaultExpandAll,
      "default-checked-keys": _vm.defaultCheckedKeys,
      "empty-text": _vm.$t("table.emptyText"),
      "node-key": "id",
      "highlight-current": "",
      props: _vm.defaultProps,
    },
    on: { check: _vm.checkTree },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }